import { elementAttributes } from "../types/element-attributes";
import { handleError } from "../utils/handle-error";
export const domModAttr = (element, attributeName, value) => {
    if (value !== undefined) {
        element.setAttribute(attributeName, value);
    }
    else {
        element.removeAttribute(attributeName);
    }
};
export const domGetAttr = (element) => {
    const target = element.target || element.srcElement;
    const name = domGetName(target);
    const [metaError, metaResult] = handleError(() => JSON.parse(target.getAttribute(elementAttributes.meta)));
    if (metaError) {
        console.warn("[Tracking] Error parsing meta:", metaError);
        return;
    }
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (target.id && { elementId: target.id })), (name && { elementName: name })), (target.className && { elementClass: target.className })), (target.getAttribute(elementAttributes.key) && {
        key: target.getAttribute(elementAttributes.key),
    })), (metaResult && Object.assign({}, metaResult))), (target.getAttribute(elementAttributes.action) && {
        meta: target.getAttribute(elementAttributes.action),
    })), { element: target.tagName });
};
export const domGetName = (element) => {
    const name = element.getAttribute("formcontrolname") /* check formcontrolname */
        ? element.getAttribute("formcontrolname") /* pull formcontrolname */
        : element.getAttribute("name") /* check name instead */
            ? element.getAttribute("name") /* pull name */
            : element.tagName === "BUTTON"
                ? element.innerHTML
                : "";
    return name;
};



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/utils/dom.js
// module id = ./node_modules/@celine/passive-tracking/dist/utils/dom.js
// module chunks = 0